module.exports = __webpack_public_path__ + "media/cashsound.41924df0.mp3";